import config from "config";
import { APICore } from "helpers/api/apiCore";
import { IntegrationLogReportPayload } from "./types";

const api = new APICore();
function createIntegLogReportApi(params: IntegrationLogReportPayload) {
    let backendApiUrl = `${config.BACKEND_BASE_URL}/report/integ-log-report`;
    return api.create(`${backendApiUrl}`, params);
}

export { createIntegLogReportApi };